import { render, staticRenderFns } from "./BaseDialogForm.vue?vue&type=template&id=7e01c0ca&scoped=true"
import script from "./BaseDialogForm.vue?vue&type=script&lang=js"
export * from "./BaseDialogForm.vue?vue&type=script&lang=js"
import style0 from "./BaseDialogForm.vue?vue&type=style&index=0&id=7e01c0ca&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e01c0ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\0.资料\\项目\\girdear_mall_center_web\\node_modules\\.store\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e01c0ca')) {
      api.createRecord('7e01c0ca', component.options)
    } else {
      api.reload('7e01c0ca', component.options)
    }
    module.hot.accept("./BaseDialogForm.vue?vue&type=template&id=7e01c0ca&scoped=true", function () {
      api.rerender('7e01c0ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/BaseDialogForm.vue"
export default component.exports